export default "__VITE_ASSET__ahf3yqmc__"